import { render, staticRenderFns } from "./Question7.vue?vue&type=template&id=057b94ed"
import script from "./Question7.vue?vue&type=script&lang=js"
export * from "./Question7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports